import { Product } from '../hooks/useProducts';
import { Prize, ProductOrPrize } from '../types/game';

export const distributeItemsEvenly = (
  productsToDistribute: Product[],
  prizesToDistribute: Prize[]
): ProductOrPrize[] => {
  const productItems: ProductOrPrize[] = productsToDistribute.map((p) => ({ type: 'product', item: p }));

  if (prizesToDistribute.length === 0) return productItems;
  if (productItems.length === 0) {
    console.error('Cannot distribute prizes with no products');
    return prizesToDistribute.map((p) => ({ type: 'prize', item: p }));
  }

  const result: ProductOrPrize[] = [...productItems];

  if (prizesToDistribute.length === 1) {
    result.unshift({ type: 'prize', item: prizesToDistribute[0] });
  } else if (prizesToDistribute.length === 2) {
    result.unshift({ type: 'prize', item: prizesToDistribute[0] });
    result.push({ type: 'prize', item: prizesToDistribute[1] });
  } else if (prizesToDistribute.length >= 3) {
    const totalPositions = result.length + prizesToDistribute.length;

    result.unshift({ type: 'prize', item: prizesToDistribute[0] });

    const lastPrize = prizesToDistribute[prizesToDistribute.length - 1];

    const middlePrizes = prizesToDistribute.slice(1, -1);

    if (middlePrizes.length > 0) {
      const availableMiddlePositions = totalPositions - 2;
      const spacing = Math.floor(availableMiddlePositions / (middlePrizes.length + 1));

      middlePrizes.forEach((prize, index) => {
        const insertPosition = (index + 1) * spacing + 1;
        const actualPosition = Math.min(insertPosition, result.length);
        result.splice(actualPosition, 0, { type: 'prize', item: prize });
      });
    }

    result.push({ type: 'prize', item: lastPrize });
  }

  return result;
};
